import { useState } from "react";
import type { ServerFile } from "../../types/ServerFile";
import { humanFileSize, toBase64 } from "../../tools/utils";
import  ImageIcon  from "./ImageIcon";
import { useTrads } from "../../contexts/trads/useTrads";




interface Props {
  value: ServerFile[]|undefined
  name: string
  onChange: (value: number[]|ServerFile[]) => void
  onBlur?: () => void
  disabled?: boolean
  accept:string
}


function AttachmentsSelector({ value, name, onChange, onBlur, disabled,accept }: Props){
    const [files,setFiles]=useState(value??[]);
    const {translate}=useTrads();
    const handleChange = async (event:React.ChangeEvent<HTMLInputElement >) => {
        if(event.target.files){
            for (const file of event.target.files) {
                const f:ServerFile ={filename:"",filedata:"",mimetype:"",filesize:0}
                f.filename=file.name
                f.filedata = await toBase64(file);
                f.mimetype=file.type;
                f.filesize=file.size;
                addFile(f);
            }
            if(event.target.parentNode){
                event.target.value='';
                event.target.type='text';
                event.target.type='file';

            }
        }
    }

    function addFile(file:ServerFile){
        const newfiles=[...files,file];
        setFiles(newfiles);
        onChange(newfiles);
    }
    function removeFile(file:ServerFile){ //pe faudrai passer l'index!
        /*
        const newfiles=files.filter((e)=> e!==file);
        setFiles(newfiles);
        onChange(newfiles);
        */
        //const newfiles=[...files.filter((e)=> e!==file),file];
        const newfiles=files.map(e => {
            if (e==file){
                if(e.filedata){
                    return null
                } else{
                    e.removed=!e.removed;
                }
                return e;
            } 
            else{
                return e;
            }
            
        }).filter((e)=> e!=null);
        setFiles(newfiles);

        onChange(newfiles);
    }



    return (
        <ul onBlur={onBlur} data-name={name} data-disbled={disabled} className="files">
        {files.map((f)=>{
            return (
                <li key={f.filename} onClick={()=>{removeFile(f);}} className={(f.removed)?'removed':''}>
                    
                    <ImageIcon mimetype={f.mimetype} /> 
                    {f.filename} {f.filesize ?<small>{humanFileSize(f.filesize)}</small>:null}
                </li>
            )
        })}
        <li >
            <label className="form-label">  {translate('attachment_add')}
            <input className="form-control" name={name} type="file" onChange={(e)=> void handleChange(e)} accept={accept} />
            </label>
        </li>
        </ul>
    );
}
export default AttachmentsSelector;